import { BACKEND_PUBLIC } from './base'

export async function uploadFile(base64: string) {
  return BACKEND_PUBLIC.post<{ url: string }>('/upload/file', { base64 })
}
